// dayjs with the Russian locale; antd date pickers use the same instance.
import dayjs, { type Dayjs } from 'dayjs';
import 'dayjs/locale/ru';

dayjs.locale('ru');

export const DATE_FORMAT = 'DD.MM.YYYY';
export const API_DATE_FORMAT = 'YYYY-MM-DD';
export const DATE_TIME_FORMAT = 'DD.MM.YYYY HH:mm';

/** "2026-09-17" -> Dayjs (null for empty). */
export function fromApiDate(value: string | null | undefined): Dayjs | null {
  return value ? dayjs(value) : null;
}

/** Dayjs -> "2026-09-17" (null for empty). */
export function toApiDate(value: Dayjs | null | undefined): string | null {
  return value ? value.format(API_DATE_FORMAT) : null;
}

/** "2026-09-17" -> "17.09.2026". */
export function formatDate(value: string | null | undefined): string {
  return value ? dayjs(value).format(DATE_FORMAT) : '';
}

/** ISO timestamp -> "17.09.2026 10:00" in the browser's time zone (Tashkent on site). */
export function formatDateTime(value: string | null | undefined): string {
  return value ? dayjs(value).format(DATE_TIME_FORMAT) : '';
}

/** Full years between an ISO birth date and today. */
export function ageInYears(birthDate: string): number {
  return dayjs().diff(dayjs(birthDate), 'year');
}

export function today(): Dayjs {
  return dayjs().startOf('day');
}

export { dayjs };
export type { Dayjs };
